import { filter, map, OperatorFunction } from 'rxjs';
import { IMessage } from '../message';

/**
 * @param staticOverrides Provide static values for overwrite
 *
 * @returns
 * Operator that takes a source that emits with an array of elements and
 * an partial element. The operator tries to find the partial element
 * in the array of elements and emits a new version where the
 * element from the array os overwritten by the partial element.
 *
 * If the element could not be found, nothing will emit.
 */
export function findAndOverwrite<T extends IMessage>(
  staticOverrides: Partial<IMessage> = {},
): OperatorFunction<[T[], Partial<T>], T> {
  return (obs$) =>
    obs$.pipe(
      map<[T[], Partial<T>], T | undefined>(
        ([messages, { key, ...otherProps }]) => {
          const message = messages.find((m) => m.key === key);
          return message
            ? {
                ...message,
                ...otherProps,
                ...staticOverrides,
              }
            : undefined;
        },
      ),
      filter((m): m is T => !!m),
    );
}
